// @flow
import { receiveHomes, renamedHome, renameHome } from './actions';
import { findIndex, set } from 'lodash/fp';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    [receiveHomes.toString()]: handleReduce((state, { payload: { homes } }) => ({
        ...state,
        homeItems: homes || []
    })),
    [renameHome.toString()]: handleReduce(
        (state, { payload }) => ({
            ...state,
            isRenaming: true
        }),
        state => ({
            ...state,
            isRenaming: false
        })
    ),
    [renamedHome.toString()]: handleReduce((state, { payload }) => {
        const index = findIndex(x => x.id === payload.home, state.homeItems);
        if (index > -1) {
            return { ...set(['homeItems', index, 'name'], payload.name, { ...state }), isRenaming: false };
        }
        return {
            ...state,
            homeItems: [...state.homeItems, payload],
            isRenaming: false
        };
    })
};

export default handleActions(actionHandlers, {
    homeItems: [],
    isRenaming: false
});



// WEBPACK FOOTER //
// ./src/core/state/homes/index.js